"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakePayIn = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var apps_shared_1 = require("@l2p/apps-shared");
var useMakePayIn = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: function (args) {
            successAction === null || successAction === void 0 ? void 0 : successAction(args);
            (0, apps_shared_1.gtagEvent)(apps_shared_1.GtagEvents.DEPOSIT_SUCCESS_INIT);
        },
        errorAction: function (args) {
            errorAction === null || errorAction === void 0 ? void 0 : errorAction(args);
            (0, apps_shared_1.gtagEvent)(apps_shared_1.GtagEvents.DEPOSIT_FAILED_INIT);
        },
        keysUpdate: [keys_1.BALANCE, keys_1.BONUSES_BY_TYPE, keys_1.PROFILE_LAST_DEPOSIT_TRANSACTION],
        path: keys_1.PAY_IN_MAKE,
    }), data = _c.data, mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        makePayIn: mutate,
        isSubmitting: isSubmitting,
        error: error,
        data: data,
    }); }, [mutate, isSubmitting, error]);
};
exports.useMakePayIn = useMakePayIn;
